<template>
  <div class="header-box">
    <div class="header auto-box">
      <div class="logo-box">
        <img v-if="headImg" :src="headImg" alt="logo" class="logo" />
        <span class="title">{{ headTitle }}</span>
      </div>
      <div class="flex">
        <span class="home" @click="backOriginHome" v-if="showBackText()">
          返回
        </span>
        <div>
          <img :src="userinfo.imageUrl" class="avatar" v-if="userinfo" />
          <a-dropdown>
            <span style="cursor: pointer" v-if="userinfo">{{
              userinfo.name ? userinfo.name : checkPhone(userinfo.phone)
            }}</span>
            <template #overlay>
              <a-menu>
                <!-- change 1 -->
                <a-menu-item v-if="isPlayPage">
                  <router-link target="_blank" :to="{ path: '/my' }"
                    >个人中心</router-link
                  >
                  <!-- <span @click="mineWebHome">个人中心</span>  -->
                </a-menu-item>
                <a-menu-item>
                  <span @click="logoutBtn">退出登录</span>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// change 1,产品需求：https://thoughts.aliyun.com/workspaces/5f1107614b995d001ef93002/docs/627924ffdcb1eb0001dfb5b2
import { defineComponent, computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { getHeaderImg, _backUrl } from "@/utils/help.js";
import { useRouter, useRoute } from "vue-router";
import { Modal } from "ant-design-vue";
import { logout } from "@/api/user";
import { onBeforeRouteUpdate } from "vue-router";

export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const headImg = ref("");
    const headTitle = ref("");
    const backOriginHome = async () => {
      // 有backUrl 优先backUrl，否则就是普通返回
      let backUrl = router.currentRoute.value.query._back_url;
      if (backUrl) {
        _backUrl(backUrl);
      } else if (sessionStorage.getItem("_back_url")) {
        _backUrl(sessionStorage.getItem("_back_url"));
      } else {
        router.back();
      }
    };
    let big_origin = ref("");
    let isPlayPage = ref(false);
    const userinfo = computed(() => store.getters["user/getUserInfo"]);
    const showBackText = () => {
      // 有_big_origin 并且不是ms和模块平台
      return (
        big_origin.value &&
        big_origin.value !== "THEME_MS" &&
        !big_origin.value?.startsWith("PLATFORM_ID_")
      );
    };
    onMounted(() => {
      big_origin.value =
        sessionStorage.getItem("_big_origin") || route.query._big_origin || "";
      if (route.name === "Play") {
        if (
          ["NERVE", "THEME_MS", "THEME_PM", "THEME_STROKE"].includes(
            big_origin.value
          ) ||
          (big_origin.value && big_origin.value.includes("PLATFORM_ID_"))
        ) {
          isPlayPage.value = false;
        } else {
          isPlayPage.value = true;
        }
      }
      _initHeaderImg();
    });

    const checkPhone = (oriPhone) => {
      return oriPhone && oriPhone.split("").fill("*", 3, 7).join("");
    };

    onBeforeRouteUpdate(() => {});
    const logoutBtn = () => {
      Modal.confirm({
        title: "确认退出吗？",
        content: "",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          logout({ source: "PC" }).then(() => {
            store.commit("user/setUserInfo", null);
            localStorage.clear();
            sessionStorage.clear();
            // 有backUrl 优先backUrl，否则就是返回到登录页
            if (route.query._back_url) {
              window.location.replace(route.query._back_url);
            } else {
              router.replace("/login");
            }
          });
        },
        onCancel() {},
      });
    };
    const mineWebHome = () => {
      let url = router.resolve({ path: "/study" });
      window.open(url);
    };
    const _initHeaderImg = async () => {
      const imgPendding = await getHeaderImg();
      if (Array.isArray(imgPendding)) {
        headTitle.value = imgPendding[0];
        headImg.value = imgPendding[1];
        if (headImg.value) {
          headTitle.value = "";
        }
      } else {
        headImg.value = imgPendding.default;
      }
    };

    return {
      backOriginHome,
      big_origin,
      isPlayPage,
      logoutBtn,
      mineWebHome,
      checkPhone,
      headImg,
      headTitle,
      userinfo,
      showBackText,
    };
  },
});
</script>

<style scoped lang="less">
.header-box {
  background: #ffffff;
  box-shadow: 0px 1px 4px 0px rgba(0, 21, 41, 0.12);
  position: relative;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // width: 100%;
  height: 60px;
  // position: fixed;
  // background-color: #fff;
  // z-index: 10;

  .logo-box {
    display: flex;
    align-items: center;
    .logo {
      height: 36px;
      margin-right: 12px;
    }
    .title {
      font-weight: 600;
      font-size: 15px;
      color: #3c3d3f;
    }
  }
  .avatar {
    width: 28px;
    height: 28px;
    margin-right: 12px;
  }
  .home {
    margin-right: 50px;
    font-size: 15px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 23px;
    cursor: pointer;
  }
}
</style>
